function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length) linkElements.forEach(button => {
          button.removeAttribute('tabindex');
        });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length) linkElements.forEach(button => {
          button.setAttribute('tabindex', '-1');
        });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

function initializeIncubaliaRecommendedProducts(root = document) {
  const containers = [];

  if (root instanceof Element && root.matches('.product-recommendations')) {
    containers.push(root);
  }

  if (typeof root.querySelectorAll === 'function') {
    containers.push(...root.querySelectorAll('.product-recommendations'));
  }

  containers.forEach((container) => {
    const list = container.querySelector('.recommended-products-list');
    const items = list ? Array.from(list.querySelectorAll('.recommended-item')) : [];
    const limit = parseInt(container.dataset.productListLimit, 10);

    if (list && items.length) {
      items
        .sort((firstItem, secondItem) => {
          const firstStock = parseInt(firstItem.dataset.recommendationStock || '0', 10);
          const secondStock = parseInt(secondItem.dataset.recommendationStock || '0', 10);

          return secondStock - firstStock;
        })
        .forEach((item, index) => {
          list.appendChild(item);

          const isVisible = Number.isNaN(limit) || index < limit;
          item.style.display = isVisible ? '' : 'none';
          item.toggleAttribute('hidden', !isVisible);
        });
    }

    const recommendationVideo = container.querySelector('.product-recommendations__video video');
    const videoButton = container.querySelector('.product-recommendations__video-button');
    const muteButton = container.querySelector('.product-recommendations__video-button__mute');
    const playButton = container.querySelector('.product-recommendations__video-button__play');

    if (recommendationVideo && videoButton && !videoButton.dataset.audioControlInitialized) {
      videoButton.dataset.audioControlInitialized = 'true';
      videoButton.addEventListener('click', () => {
        const currentTime = Math.floor(recommendationVideo.currentTime);

        if (muteButton) {
          const isMuted = recommendationVideo.muted;
          recommendationVideo.muted = !isMuted;
          videoButton.setAttribute('aria-label', isMuted ? 'Desactivar audio del video' : 'Activar audio del video');

          if (typeof gtag === 'function') {
            gtag('event', 'video-recomendador-productos', {
              event_category: isMuted ? 'Activar audio' : 'Desactivar audio',
              event_label: `${isMuted ? 'Activar' : 'Desactivar'} audio al segundo ${currentTime}`
            });
          }

          if (recommendationVideo.paused) {
            recommendationVideo.play().catch(() => {});
          }

          return;
        }

        if (playButton) {
          if (recommendationVideo.paused) {
            recommendationVideo.play().catch(() => {});
            videoButton.setAttribute('aria-label', 'Pausar video');
          } else {
            recommendationVideo.pause();
            videoButton.setAttribute('aria-label', 'Reproducir video');
          }
        }
      });
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initializeIncubaliaRecommendedProducts());
} else {
  initializeIncubaliaRecommendedProducts();
}

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.hideOutofstockRecommendations();
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    // Incubalia Recommendation
    // this.updateRecommendations();
    // Incubalia Out Of Stock recommendations
    this.updateOutOfStockRecommendations();
    this.updateWaitAndSave();
    this.updateOutOfStockCalendar();
    // Incubalia New Recommendations
    this.updateNewRecommendations();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  // Incubalia
  updateNewRecommendations() {
    if (this && this.tagName.toLowerCase() === 'variant-radios') return;
    const recommendations = document.querySelectorAll('.product-recommendations');
    if (!recommendations[0]) return;
    let url = `${recommendations[0].dataset.url}?variant=${this.currentVariant.id}`;
    fetch(url)
    .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`Product-Recommendations`);
        const source = html.getElementById(`Product-Recommendations`);

        if (source && destination) {
          const activeRecommendationVideo = destination.querySelector('.product-recommendations__video');
          destination.innerHTML = source.innerHTML;

          if (activeRecommendationVideo) {
            const refreshedRecommendationVideo = destination.querySelector('.product-recommendations__video');

            if (refreshedRecommendationVideo) {
              refreshedRecommendationVideo.replaceWith(activeRecommendationVideo);
            }
          }

          initializeIncubaliaRecommendedProducts(destination);

          const recommendationVideoWrapper = destination.querySelector('.product-recommendations__video');
          const recommendationVideo = recommendationVideoWrapper ? recommendationVideoWrapper.querySelector('video') : null;
          const recommendationVideoButton = recommendationVideoWrapper ? recommendationVideoWrapper.querySelector('.product-recommendations__video-button') : null;
          const isOutOfStock = this.currentVariant && variantStocks[this.currentVariant.title] <= 0;

          if (recommendationVideoWrapper) {
            recommendationVideoWrapper.style.display = isOutOfStock ? 'block' : 'none';
          }

          if (recommendationVideo) {
            if (isOutOfStock) {
              recommendationVideo.muted = false;
              recommendationVideo.defaultMuted = false;
              recommendationVideo.volume = 1;

              if (recommendationVideoButton) {
                recommendationVideoButton.setAttribute('aria-label', 'Desactivar audio del video');
              }

              recommendationVideo.play().catch((error) => {
                console.log('No se ha podido reproducir el video con audio:', error);
              });
            } else {
              recommendationVideo.currentTime = 0;
              recommendationVideo.pause();
              recommendationVideo.muted = true;
              recommendationVideo.defaultMuted = true;

              if (recommendationVideoButton) {
                recommendationVideoButton.setAttribute('aria-label', 'Activar audio del video');
              }
            }
          }
        }
      });
  }

  updateRecommendations() {
    if (this && this.tagName.toLowerCase() === 'variant-radios') return;
    const recommendations = document.querySelectorAll('upsell-variant-selects');
    if (!recommendations) return;
    const selector = `Option-${this.dataset.section}-0`;
    let variantSize = document.getElementById(selector).value;
    recommendations.forEach(recommendation => recommendation.updateRecommendations(variantSize));
  }
  updateOutOfStockRecommendations() {
    if (this && this.tagName.toLowerCase() === 'variant-radios') return;
    const recommendations = document.querySelectorAll('variant-select-stock');
    if (!recommendations) return;
    const selector = `Option-${this.dataset.section}-0`;
    let variantSize = document.getElementById(selector).value;
    recommendations.forEach(recommendation => recommendation.updateRecommendations(variantSize));
    if (variantStocks[variantSize] <= 0) {
      this.showOutofstockRecommendations();
    }
  }
  hideOutofstockRecommendations() {
    if (this && this.tagName.toLowerCase() === 'variant-radios') return;
    const recommendations = document.getElementById('outofstock-recommendations');
    if (!recommendations) return;
    recommendations.style.display = 'none';
  }
  showOutofstockRecommendations() {
    if (this && this.tagName.toLowerCase() === 'variant-radios') return;
    const recommendations = document.getElementById('outofstock-recommendations');
    if (!recommendations) return;
    recommendations.style.display = 'block';
  }
  updateWaitAndSave() {
    if (this && this.tagName.toLowerCase() === 'variant-radios') return;
    const waitAndSave = document.getElementById('Wait-and-save');
    const waitAndSaveLabel = document.getElementById('Wait-and-save__label');
    if (!waitAndSave) return;
    if (variantStocks[this.currentVariant.title] <= 0) {
      waitAndSave.style.display = 'block';
      waitAndSaveLabel.style.display = 'block';
    } else {
      waitAndSave.style.display = 'none';
      waitAndSaveLabel.style.display = 'none';
    }
  }

  updateOutOfStockCalendar() {
    if (this && this.tagName.toLowerCase() === 'variant-radios') return;
    const outOfStockCalendar = document.getElementById('out-of-stock-calendar');
    const primeMessage = document.getElementById('prime-message');
    const waitPromoVideoWrapper = document.querySelector('.product-recommendations__video')
    const waitPromoVideo = document.querySelector('.product-recommendations__video video')

    if (!outOfStockCalendar) return;
    if (variantStocks[this.currentVariant.title] <= 0) {
      outOfStockCalendar.style.display = 'block';
      primeMessage.style.display = 'none';
      document.getElementById('latest_sending_date').value = nextManufacturingDay.toISOString().split('T')[0];
      document.getElementById('latest_arriving_date').value = nextFinishDeliveryDay.toISOString().split('T')[0];

      if (waitPromoVideo) {
        const waitPromoVideoButton = waitPromoVideoWrapper.querySelector('.product-recommendations__video-button');
        waitPromoVideo.currentTime = 0;
        waitPromoVideo.muted = false;
        waitPromoVideo.defaultMuted = false;
        waitPromoVideo.volume = 1;
        waitPromoVideoWrapper.style.display = 'block';
        if (waitPromoVideoButton) {
          waitPromoVideoButton.setAttribute('aria-label', 'Desactivar audio del video');
        }

        waitPromoVideo.play().catch((error) => {
          console.log('No se ha podido reproducir el video con audio:', error);
        });
      }
    } else {
      outOfStockCalendar.style.display = 'none';
      primeMessage.style.display = 'block';
      document.getElementById('latest_sending_date').value = sendingPrime.toISOString().split('T')[0];
      document.getElementById('latest_arriving_date').value = arrivingPrime.toISOString().split('T')[0];

      if (waitPromoVideo) {
        const waitPromoVideoButton = waitPromoVideoWrapper.querySelector('.product-recommendations__video-button');
        waitPromoVideoWrapper.style.display = 'none';
        waitPromoVideo.currentTime = 0;
        waitPromoVideo.pause();
        waitPromoVideo.muted = true;
        waitPromoVideo.defaultMuted = true;

        if (waitPromoVideoButton) {
          waitPromoVideoButton.setAttribute('aria-label', 'Activar audio del video');
        }
      }
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue)
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true, window.variantStrings.soldOut);

        publish(PUB_SUB_EVENTS.variantChange, {data: {
          sectionId,
          html,
          variant: this.currentVariant
        }});
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class EmblaCarouselComponent extends HTMLElement {
  constructor() {
    super();
    this.embla = null;
  }

  connectedCallback() {
    this.render();
    this.loadEmblaIfNeeded()
      .then(() => {
        this.initEmbla();
        this.setupButtons();
        this.updateActiveSlide();
      })
      .catch((err) => {
        console.error('Error cargando Embla Carousel:', err);
      });
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (this.embla && (name === 'loop' || name === 'slides-desktop' || name === 'slides-mobile' || name === 'slides-toscroll' || name === 'slide-spacing')) {
      this.embla.reInit({
        loop: this.hasAttribute('loop'),
        slidesToScroll: parseInt(this.getAttribute('slides-toscroll') || '1'),
        containScroll: 'trimSnaps'
      }, true);
      this.setupButtons();
      this.updateActiveSlide();
    }
  }

  static get observedAttributes() {
    return ['loop', 'slides-desktop', 'slides-mobile', 'slides-toscroll', 'slide-spacing'];
  }

  updateCSSVars() {
    const emblaEl = this.querySelector('.embla');
    if (!emblaEl) return;

    const spacing = this.getAttribute('slide-spacing') || '10px';
    emblaEl.style.setProperty('--slide-spacing', spacing);

    // Responsive slides
    const desktopSlides = parseInt(this.getAttribute('slides-desktop') || '1');
    const mobileSlides = parseInt(this.getAttribute('slides-mobile') || '1');

    emblaEl.style.setProperty('--slides-desktop', desktopSlides);
    emblaEl.style.setProperty('--slides-mobile', mobileSlides);
  }

  render() {
    const existingContent = this.innerHTML.trim();

    if (!this.querySelector('.embla')) {
      // The generated styles belong only to carousels using this default layout.
      // A style tag in light DOM is global; :host does not scope it to this element.
      this.setAttribute('data-carousel-layout', 'default');
      this.innerHTML = `
        <div class="embla-carousel__wrapper" part="wrapper">
          <div class="embla" role="region" aria-label="Carrusel de imagenes de producto" part="embla">
            <div class="embla__container" role="list" part="container">
              ${existingContent || '<div class="embla__slide">Contingut buit</div>'}
            </div>
            <button class="embla-carousel__prev" aria-label="Anterior" tabindex="0" part="prev-btn">‹</button>
            <button class="embla-carousel__next" aria-label="Siguiente" tabindex="0" part="next-btn">›</button>
          </div>
        </div>

        <style>
          :where(custom-carousel[data-carousel-layout="default"]) {
            display: block;
            width: 100%;
            height: 100%;
            max-height: 100%;
            --slide-spacing: 10px;
            --slides-visible: 1;
          }

          :where(custom-carousel[data-carousel-layout="default"]) .embla {
            overflow: hidden;
            touch-action: pan-y;
            -webkit-overflow-scrolling: touch;
            width: 100%;
            position: relative;
            height: 100%;
            max-height: 100%;
          }

          :where(custom-carousel[data-carousel-layout="default"]) .embla__container {
            display: flex;
            user-select: none;
            -webkit-touch-callout: none;
            -webkit-tap-highlight-color: transparent;
            margin-left: calc(var(--slide-spacing) * -1);
            scroll-behavior: smooth;
            max-height: 100%;
          }

          :where(custom-carousel[data-carousel-layout="default"]) .embla__slide {
            position: relative;
            /* Desktop */
            flex: 0 0 calc(100% / var(--slides-desktop) - var(--slide-spacing) * (var(--slides-desktop) - 1) / var(--slides-desktop));
            /* Mobile */
            @media screen and (max-width: 750px) {
              flex: 0 0 calc(100% / var(--slides-mobile) - var(--slide-spacing) * (var(--slides-mobile) - 1) / var(--slides-mobile));
            }
            min-width: 0;
            padding-left: var(--slide-spacing);
            max-height: 100%;
          }

          :where(custom-carousel[data-carousel-layout="default"]) .embla__slide img,
          :where(custom-carousel[data-carousel-layout="default"]) .embla__slide video {
            width: 100%;
            height: auto;
            max-height: 100%;
            min-height: 100%;
            display: block;
            object-fit: cover;
            object-position: center center;
          }

          :where(custom-carousel[data-carousel-layout="default"]) .embla-carousel__prev,
          :where(custom-carousel[data-carousel-layout="default"]) .embla-carousel__next {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            background: rgba(0,0,0,0.5);
            border: none;
            border-radius: 50%;
            color: white;
            padding: 0.5em 1em;
            cursor: pointer;
            z-index: 2;
            user-select: none;
            width: 40px;
            height: 40px;
          }

          :where(custom-carousel[data-carousel-layout="default"]) .embla-carousel__prev { left: 10px; }
          :where(custom-carousel[data-carousel-layout="default"]) .embla-carousel__next { right: 10px; }
          :where(custom-carousel[data-carousel-layout="default"]) .embla-carousel__prev:focus,
          :where(custom-carousel[data-carousel-layout="default"]) .embla-carousel__next:focus {
            outline: 2px solid #fff;
          }

          @media screen and (max-width: 750px) {
            :where(custom-carousel[data-carousel-layout="default"]) .embla-carousel__prev,
            :where(custom-carousel[data-carousel-layout="default"]) .embla-carousel__next {
              width: 25px;
              height: 25px;
              padding: 0.3em 0.6em;
              font-size: 0.8em;
            }

            :where(custom-carousel[data-carousel-layout="default"][slides-visible="3"]) .embla__slide {
              flex: 0 0 100%;
            }
          }

          :where(custom-carousel[data-carousel-layout="default"]) .embla__slide--active {
            z-index: 1;
          }
        </style>
      `;
    }
  }

  loadEmblaIfNeeded() {
    return new Promise((resolve, reject) => {
      if (window.EmblaCarousel) {
        resolve();
        return;
      }
      if (this._loadingEmbla) {
        this._loadingEmbla.then(resolve).catch(reject);
        return;
      }
      this._loadingEmbla = new Promise((res, rej) => {
        const script = document.createElement('script');
        script.src = 'https://unpkg.com/embla-carousel/embla-carousel.umd.js';
        script.async = true;
        script.onload = () => res();
        script.onerror = () => rej(new Error('No se puede cargar embla-carousel.umd.js'));
        console.log('Cargando Embla Carousel desde CDN...');
        document.head.appendChild(script);
      });
      this._loadingEmbla.then(resolve).catch(reject);
    });
  }

  initEmbla() {
    if (this.embla) {
      this.embla.destroy();
    }

    this.updateCSSVars();

    const emblaEl = this.querySelector('.embla');
    if (!emblaEl) return;

    const loop = this.hasAttribute('loop');
    const slidesVisible = parseInt(this.getAttribute('slides-visible') || '1');
    const slidesToScroll = parseInt(this.getAttribute('slides-toscroll') || '1');

    const spacing = this.getAttribute('slide-spacing') || '10px';
    emblaEl.style.setProperty('--slide-spacing', spacing);
    emblaEl.style.setProperty('--slides-visible', slidesVisible);

    const options = {
      loop,
      slidesToScroll,
      containScroll: 'trimSnaps'
    };
    // Sections can reuse the carousel on mobile and keep a static desktop grid.
    if (this.hasAttribute('mobile-only')) {
      options.align = 'start';
      options.breakpoints = { '(min-width: 750px)': { active: false } };
    }
    this.embla = EmblaCarousel(emblaEl, options);
    this.setAttribute('data-carousel-ready', '');

    this.updateActiveSlide();
    this.embla.on('select', () => {
      this.updateActiveSlide();

      this.dispatchEvent(new CustomEvent('slidechange', {
        detail: { activeIndex: this.embla.selectedScrollSnap() }
      }));
    });
  }

  updateActiveSlide() {
    const slides = this.querySelectorAll('.embla__slide');

    slides.forEach(slide => {
      slide.classList.remove('embla__slide--active', 'embla__slide--previous', 'embla__slide--next');
    });

    const activeIndex = this.embla.selectedScrollSnap();

    if (slides[activeIndex]) {
      slides[activeIndex].classList.add('embla__slide--active');
    }

    const prevIndex = (activeIndex - 1 + slides.length) % slides.length;
    const nextIndex = (activeIndex + 1) % slides.length;

    if (slides[prevIndex]) {
      slides[prevIndex].classList.add('embla__slide--previous');
    }
    if (slides[nextIndex]) {
      slides[nextIndex].classList.add('embla__slide--next');
    }
  }



  setupButtons() {
    const prevBtn = this.querySelector('.embla-carousel__prev');
    const nextBtn = this.querySelector('.embla-carousel__next');
    if (!prevBtn || !nextBtn) return;

    prevBtn.onclick = () => this.embla.scrollPrev();
    nextBtn.onclick = () => this.embla.scrollNext();

    if (this.hasAttribute('mobile-only')) {
      const updateButtons = () => {
        prevBtn.disabled = !this.embla.canScrollPrev();
        nextBtn.disabled = !this.embla.canScrollNext();
      };
      updateButtons();
      this.embla.on('select', updateButtons);
      this.embla.on('reInit', updateButtons);
    }
  }

  disconnectedCallback() {
    if (this.embla) this.embla.destroy();
    this.removeAttribute('data-carousel-ready');
  }
}

customElements.define('custom-carousel', EmblaCarouselComponent);
